/// <amd-module name="Build/Run/Components/Canvas/PathHelpers" />
import * as Types from "Build/Run/Components/Canvas/Types";
import { format } from "VSS/Core/Util/String";

/**
 * A simple utility which provider syntactic sugar to build a path.
 * There are no validation on the path. 
 */
export class PathBuilder {

    public start(from: Types.IPoint): PathBuilder {
        this._pathBuilder += " " + format("M{0},{1}", from.x, from.y);
        return this;
    }

    public line(to: Types.IPoint): PathBuilder {
        this._pathBuilder += " " + format("L{0},{1}", to.x, to.y);
        return this;
    }

    public quadraticBezier(to: Types.IPoint, controlPoint: Types.IPoint): PathBuilder {
        this._pathBuilder += " " + format("Q {0} {1}, {2} {3}", controlPoint.x, controlPoint.y, to.x, to.y);
        return this;
    }

    public arc(to: Types.IPoint, radiusX: number, radiusY: number, largeArcFlag: number, sweepFlag: number) {
        this._pathBuilder += " " + format("A {0} {1} {2} {3} {4} {5} {6}", radiusX, radiusY, 0, largeArcFlag, sweepFlag, to.x, to.y);
        return this;
    }

    public toString(){
        return  this._pathBuilder;
    }

    private _pathBuilder: string = "";
}
